import { Component, input, output } from '@angular/core';
import { Activity } from '@mira-avant/mtlibs';
import { NzButtonModule } from 'ng-zorro-antd/button';
import { PlayerComponent } from '../../journey/player/player.component';
import { LessonService } from '../../../../services/lesson.service';
import { JourneyStep } from '../../../pages/journey/journey.component';
import { HeaderComponent } from '../../journey/header/header.component';

@Component({
	selector: 'app-preview-activity',
	standalone: true,
	imports: [NzButtonModule, PlayerComponent, HeaderComponent],
	templateUrl: './preview-activity.html',
	styleUrl: './preview-activity.scss',
})
export class PreviewActivity {
	onClear = output<void>();
	activity = input<Activity | undefined>(undefined);
	public JourneyStep = JourneyStep;

	constructor(private lessonService: LessonService) {}

	public clear(): void {
		this.onClear.emit();
	}
}
